import React from 'react';
import { Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import Review from '../../review/Review';

const ReviewSection = (props) => {
  const {
    enrollment,
    evaluationSecIndex,
    excludedQuestions,
    review,
    reviewSurvey,
    showReviewComments,
    submission,
    survey,
  } = props;
  return (
    <div>
      <Review
        surveyIdsMatchReviewSurvey={!reviewSurvey}
        survey={survey.payload}
        reviewSurvey={reviewSurvey}
        reviewSubmission={review}
        currentSection={evaluationSecIndex}
        onCurrentSectionChange={(index) => index}
        evaluation={enrollment.certificate.evaluation}
        submission={submission}
        excludedQuestions={excludedQuestions}
        readOnly
        disableReview
        printFlag
      />
      {
          showReviewComments
          && (
          <div>
            {
              review.sectionJustifications
              && review.sectionJustifications[0] && (
                <div>
                  <Typography variant="h6"><FormattedMessage id="trialdetails.sectionReview" /></Typography>
                  <div>{review.sectionJustifications[evaluationSecIndex]}</div>
                </div>
              )
            }
            {
              review.justification && (
                <div>
                  <Typography variant="h6" fontWeight="bold"><FormattedMessage id="trialdetails.sectionOverview" /></Typography>
                  <div>{review.justification}</div>
                </div>
              )
            }
          </div>
          )
        }
    </div>
  );
};

ReviewSection.defaultProps = {
  excludedQuestions: undefined,
  reviewSurvey: undefined,
};

ReviewSection.propTypes = {
  enrollment: PropTypes.object.isRequired,
  evaluationSecIndex: PropTypes.number.isRequired,
  excludedQuestions: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.object,
    PropTypes.number,
  ]),
  review: PropTypes.object.isRequired,
  reviewSurvey: PropTypes.oneOfType([
    PropTypes.object,
  ]),
  showReviewComments: PropTypes.bool.isRequired,
  submission: PropTypes.object.isRequired,
  survey: PropTypes.object.isRequired,
};

export default ReviewSection;
